import { DownloadUploadsListDialog } from "./shared/dialogs/DownloadUploadsListDialog"
import { useState, cloneElement } from "react"

export function DownloadUploadsComponent({ button, notificationId }: {
    button: React.ReactElement,
    notificationId?: string,
}) {
  const [downloadUploadsListDialogOpen, setDownloadUploadsListDialogOpen] = useState(false)

  return (<>
    {cloneElement(button as React.ReactElement, {
      onClick: () => setDownloadUploadsListDialogOpen(true)
    })}
    { downloadUploadsListDialogOpen && 
      <DownloadUploadsListDialog
        onClose={() => setDownloadUploadsListDialogOpen(false)}
        notificationId={notificationId}
      /> 
    }
  </>)
}